// Helpers de fecha para el frontend.
//
// Contexto del problema:
// El backend usa SQL Server con DATETIME (sin TZ) y `GETDATE()` que graba la
// hora local del server (Argentina, UTC-3). El driver mssql está configurado
// con `useUTC: true` por default, lo que mal-interpreta esos DATETIME como
// UTC al leerlos. Resultado: el frontend recibe ISO con 'Z' que está
// shifteado 3 horas respecto a la hora real local.
//
// Tampoco podemos confiar en `new Date('2026-05-06 12:09:00')` (espacio):
// según el spec ECMAScript, formatos sin TZ se interpretan como UTC en
// algunos engines y como local en otros — comportamiento inconsistente.
//
// Solución: parsear los componentes con regex y construir el Date con los
// argumentos numéricos (que JS *siempre* interpreta como hora LOCAL),
// ignorando cualquier 'Z' o offset que venga en el string. Es seguro
// asumir local porque el backend solo graba/devuelve hora local Argentina.

export function parseFechaServer(s) {
    if (!s) return null;
    if (s instanceof Date) return isNaN(s.getTime()) ? null : s;
    const str = String(s);
    const m = str.match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (m) {
        return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    }
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
}

/** Texto relativo "Ahora / Hace Nm / Hace Nh / Ayer HH:mm / Hace N días / fecha". */
export function tiempoRelativo(fecha) {
    const d = parseFechaServer(fecha);
    if (!d) return '';
    const now = new Date();
    const diffMs = now - d;
    const diffMin = Math.floor(diffMs / 60000);
    if (diffMin < 1) return 'Ahora';
    if (diffMin < 60) return `Hace ${diffMin}m`;
    const diffH = Math.floor(diffMin / 60);

    if (now.toDateString() === d.toDateString()) return `Hace ${diffH}h`;

    const ayer = new Date(now); ayer.setDate(ayer.getDate() - 1);
    const hh = String(d.getHours()).padStart(2, '0');
    const mi = String(d.getMinutes()).padStart(2, '0');
    if (ayer.toDateString() === d.toDateString()) return `Ayer ${hh}:${mi}`;

    const diffD = Math.floor(diffH / 24);
    if (diffD < 7) return `Hace ${diffD} días`;
    return d.toLocaleDateString('es-AR');
}
